var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CallBackForm from './CallBackForm';
import CallBackInvestment from './CallBackInvestment';
import styles from './CallBack.module.css';
import ModalThankYou from '../ModalThankYou';
var CallBackFormState;
(function (CallBackFormState) {
    CallBackFormState[CallBackFormState["SIGN_UP"] = 0] = "SIGN_UP";
    CallBackFormState[CallBackFormState["INVESTMENT"] = 1] = "INVESTMENT";
    CallBackFormState[CallBackFormState["THANK_YOU"] = 2] = "THANK_YOU";
})(CallBackFormState || (CallBackFormState = {}));
export default function CallBack(_a) {
    var _this = this;
    var _b;
    var _c = _a.label, label = _c === void 0 ? "callback.form.submit" : _c, _d = _a.source, source = _d === void 0 ? "callback" : _d, _e = _a.isPrimary, isPrimary = _e === void 0 ? false : _e, project = _a.project;
    var _f = useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = useState(false), isHover = _g[0], setIsHover = _g[1];
    var _h = useState(CallBackFormState.SIGN_UP), step = _h[0], setStep = _h[1];
    var _j = useState({ email: '', lastName: '', firstName: '', phone: '' }), lead = _j[0], setLead = _j[1];
    var _k = useState(0), amount = _k[0], setAmount = _k[1];
    var t = useTranslation().t;
    var ref = useRef(null);
    var onNext = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (step === CallBackFormState.SIGN_UP) {
                setStep(CallBackFormState.INVESTMENT);
            }
            else if (step === CallBackFormState.INVESTMENT) {
                if (lead.email) {
                    setStep(CallBackFormState.THANK_YOU);
                    setIsOpen(false);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var close = function (e) {
        if (e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };
    var onOpen = function () {
        setIsOpen(true);
    };
    if (CallBackFormState.THANK_YOU === step) {
        return _jsx(ModalThankYou, { project: project, lead: lead, amount: amount });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("button", { type: "button", "data-transaction-name": label, onClick: onOpen, onMouseEnter: function () { return setIsHover(true); }, onMouseLeave: function () { return setIsHover(false); }, className: "".concat(styles.button, " ").concat(isPrimary ? 'primary' : ''), ref: ref, children: [(!isPrimary)
                        && (_jsx(FontAwesomeIcon, { icon: "phone", className: styles.icon, style: (isHover || isOpen) ? { transform: "translateX(".concat((ref.current ? (((_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) - 64) : 0) / 2, "px)") } : {} })), _jsxs("span", { className: styles.text, style: ((isOpen || isHover) && !isPrimary) ? { opacity: 0 } : {}, children: [" ", t(label), " "] }), (isPrimary)
                        && (_jsx(FontAwesomeIcon, { icon: "arrow-right", className: styles.arrow }))] }), (isOpen) && (_jsx("div", { className: styles.background, onClick: close, children: _jsxs("section", { className: styles.modal, children: [(step === CallBackFormState.SIGN_UP)
                            && (_jsx(CallBackForm, { onNext: onNext, source: source, project: project, setLead: setLead })), (step === CallBackFormState.INVESTMENT)
                            && (_jsx(CallBackInvestment, { onNext: onNext, source: source, email: lead.email, project: project, amount: amount, setAmount: setAmount }))] }) }))] }));
}
